import { render, staticRenderFns } from "./AppLink.vue?vue&type=template&id=bda8bf4c&scoped=true&lang=pug"
import script from "./AppLink.vue?vue&type=script&lang=js"
export * from "./AppLink.vue?vue&type=script&lang=js"
import style0 from "./AppLink.vue?vue&type=style&index=0&id=bda8bf4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda8bf4c",
  null
  
)

export default component.exports